import { render, staticRenderFns } from "./resourceRank.vue?vue&type=template&id=4639ac1b&scoped=true&"
import script from "./resourceRank.vue?vue&type=script&lang=js&"
export * from "./resourceRank.vue?vue&type=script&lang=js&"
import style0 from "./resourceRank.vue?vue&type=style&index=0&id=4639ac1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639ac1b",
  null
  
)

export default component.exports